import { api } from "../api"

export function GetAddresssByZipcode(zipcode: string) {
    return api.get(`api/person/GetAddressByZipCode/${zipcode}`)
}